<template>
	<div>
		<!-- 头 -->
		<div style="width: 100%; height: 60px; background-color:#01714D">
			<div style="
					          float:left;
					          margin-left: 15px;
					          padding-top: 14px;
					          font-size: 22px;
					          color: white;
					          font-family: Sans-serif;
					        ">
				迈亚—人力资源系统
			</div>
			<div style="float: right;">
				<img src="../src/assets/退出登录.png" style="padding:15px 30px; width:25px;height:25px" @click="signout()">
			</div>
			<div style="float: right;">
				<img src="../src/assets/修改密码.png" style="padding:15px 30px; width:25px;height:25px" @click="Uppwd">
			</div>
		</div>
		<router-view class="Route" style="
					        width: 86.6%;
					        float: right;
					        background-color: #f7f8fa;
					        min-height: 880px;"></router-view>

		<div>
			<!-- 左上角头像 -->
			<div style="
					          width: 13.7%;
					          height: 130px;
					          border-right: 1px solid #e7eaeb;
					          border-bottom: 1px solid #e7eaeb;
					        ">
				<div style="height: 20px; width: 25px"></div>
				<div style="
									margin: 0px auto;
					            width: 70px;
					            height: 70px;
					            border-radius: 35px;
					          ">
					<img src="../src/assets/用户头像.png" style="width: 100%; height: 100%" />
				</div>
				<!-- <div style="font-size: 12px; margin-top: 10px">{{ Name_ }}</div> -->
				<div style="font-size: 12px; margin-top: 10px; text-align: center; ">{{ user_name }}</div>
			</div>

			<!-- 侧方导航栏 -->
			<div style="width:13.7%" class="box">
				<el-row class="tac" style="height: 750px;overflow-x: hidden">
					<el-col :span="24">

						<el-scrollbar class="page-scroll">
							<el-menu active-text-color="#02704D" style="height:100%;margin-left:10px">
								<el-menu-item index="1" @click="goTo('Home')">
									<img src="../src/assets/导航_首页.png">
									<span slot="title">&nbsp;首页</span>
								</el-menu-item>

								<el-submenu index="2">
									<template slot="title"><img src="../src/assets/员工档案管理.png">&nbsp;&nbsp;员工档案管理</template>
									<el-menu-item-group>
										<el-menu-item v-if="Jurisdiction.contract == 'contract'" index="2-1"
											@click="goTo('HtmbGL')">模板管理</el-menu-item>
										<el-menu-item v-if="Jurisdiction.Examine == 'Examine'" index="2-2"
											@click="goTo('HtmbSH')">合同模板审核</el-menu-item>
										<el-menu-item v-if="Jurisdiction.launch == 'launch'" index="2-3"
											@click="goTo('HtqdFQ')">合同签订发起</el-menu-item>
										<el-menu-item v-if="Jurisdiction.ContractSigning == 'ContractSigning'" index="2-4"
											@click="goTo('Htqd')">合同签订</el-menu-item>
										<el-menu-item v-if="Jurisdiction.ContractArchiving == 'ContractArchiving'"
											index="2-5" @click="goTo('Htgd')">合同归档</el-menu-item>
										<el-menu-item v-if="Jurisdiction.profileInformation == 'profileInformation'"
											index="2-6" @click="goTo('Ygdaxx')">员工档案信息</el-menu-item>
										<el-menu-item v-if="Jurisdiction.titleManagement == 'titleManagement'" index="2-7"
											@click="goTo('Jfmtgl')">合同名头管理</el-menu-item>
										<el-menu-item v-if="Jurisdiction.FilesProjectContract == 'FilesProjectContract'"
											index="2-8" @click="goTo('Xmht')">项目合同</el-menu-item>
									</el-menu-item-group>
								</el-submenu>

								<el-submenu index="3">
									<template slot="title"><img src="../src/assets/基础人事管理.png">&nbsp;&nbsp;基础人事管理</template>
									<el-menu-item-group>
										<el-menu-item v-if="Jurisdiction.organization == 'organization'" index="3-1"
											@click="goTo('Jtzzjg')">集团组织架构管理</el-menu-item>
										<el-menu-item v-if="Jurisdiction.EmployeeList == 'EmployeeList'" index="3-2"
											@click="goTo('Ygxxlb')">员工信息列表</el-menu-item>
										<el-menu-item v-if="Jurisdiction.Induction == 'Induction'" index="3-3"
											@click="goTo('Ygrz')">员工入职</el-menu-item>
										<el-menu-item v-if="Jurisdiction.StaffContract == 'StaffContract'" index="3-4"
											@click="goTo('Yghtqd')">员工合同签订</el-menu-item>
										<el-menu-item v-if="Jurisdiction.StaffBecomeFormal == 'StaffBecomeFormal'"
											index="3-5" @click="goTo('Ygzz')">员工转正</el-menu-item>
										<el-menu-item v-if="Jurisdiction.quit == 'quit'" index="3-6" @click="goTo('Yglz')">
											员工离职</el-menu-item>
										<el-menu-item v-if="Jurisdiction.StaffTransferPost == 'StaffTransferPost'"
											index="3-7" @click="goTo('Ygtg')">员工调岗</el-menu-item>
										<el-menu-item v-if="Jurisdiction.management == 'management'" index="3-8"
											@click="goTo('Hmdgl')">黑名单管理</el-menu-item>
										<el-menu-item
											v-if="Jurisdiction.Insurance_base_management == 'Insurance_base_management'"
											index="3-9" @click="goTo('Bxjsgl')">保险基数管理</el-menu-item>
										<el-menu-item v-if="Jurisdiction.StaffGoOut == 'StaffGoOut'" index="3-10"
											@click="goTo('Wcsq')">外出申请</el-menu-item>
										<el-menu-item v-if="Jurisdiction.StaffLeave == 'StaffLeave'" index="3-11"
											@click="goTo('Qjsq')">请假申请</el-menu-item>
										<el-menu-item v-if="Jurisdiction.StaffTravel == 'StaffTravel'" index="3-12"
											@click="goTo('Ccsq')">出差申请</el-menu-item>
										<el-menu-item v-if="Jurisdiction.StaffMake == 'StaffMake'" index="3-13"
											@click="goTo('Bksq')">补卡申请</el-menu-item>
										<el-menu-item v-if="Jurisdiction.StaffOvertime == 'StaffOvertime'" index="3-14"
											@click="goTo('Jbsq')">加班申请</el-menu-item>
										<el-submenu index="3-15">
											<template slot="title">岗位支援管理</template>
											<el-menu-item v-if="Jurisdiction.StaffPostSupport == 'StaffPostSupport'"
												index="3-15-1" @click="goTo('Gwzysq')">岗位支援申请</el-menu-item>
											<el-menu-item v-if="Jurisdiction.StaffSupport == 'StaffSupport'" index="3-15-2"
												@click="goTo('Gwzy')">岗位支援</el-menu-item>
											<el-menu-item v-if="Jurisdiction.StaffSupportAccept == 'StaffSupportAccept'"
												index="3-15-3" @click="goTo('Gwzyjs')">岗位支援接收</el-menu-item>
										</el-submenu>
										<el-menu-item v-if="Jurisdiction.StaffReplacePost == 'StaffReplacePost'"
											index="3-16" @click="goTo('Dgsq')">代岗申请</el-menu-item>
										<el-menu-item v-if="Jurisdiction.StaffWages == 'StaffWages'" index="3-17"
											@click="goTo('Jcgl')">工资申请单</el-menu-item>
										<el-menu-item v-if="Jurisdiction.StaffChangeSalary == 'StaffChangeSalary'"
											index="3-18" @click="goTo('Zttx')">整体调薪</el-menu-item>
										<el-menu-item v-if="Jurisdiction.StaffExamine == 'StaffExamine'" index="3-19"
											@click="goTo('QAsp')">OA审批</el-menu-item>
									</el-menu-item-group>
								</el-submenu>

								<el-submenu index="4">
									<template slot="title"><img src="../src/assets/保险管理.png">&nbsp;&nbsp;保险管理</template>
									<el-menu-item-group>
										<el-menu-item v-if="Jurisdiction.UnpaidInsurance == 'UnpaidInsurance'" index="4-1"
											@click="goTo('Unpaid')">未缴纳保险</el-menu-item>
										<el-menu-item v-if="Jurisdiction.EmployerInsurance == 'EmployerInsurance'"
											index="4-2" @click="goTo('Gzxgl')">雇主险管理</el-menu-item>
										<el-menu-item
											v-if="Jurisdiction.Insurance_Premium_Management == 'Insurance_Premium_Management'"
											index="4-6" @click="goTo('Gzxbfgl')">雇主险保费管理</el-menu-item>
										<el-menu-item v-if="Jurisdiction.EmployerDanger == 'EmployerDanger'" index="4-3"
											@click="goTo('Gzxcx')">雇主险出险</el-menu-item>
										<el-menu-item v-if="Jurisdiction.OtherRisks == 'OtherRisks'" index="4-4"
											@click="goTo('Qtxzgl')">其他险种管理</el-menu-item>
										<el-menu-item v-if="Jurisdiction.OtherDanger == 'OtherDanger'" index="4-5"
											@click="goTo('Qtxzcx')">其他险种出险</el-menu-item>
									</el-menu-item-group>
								</el-submenu>

								<el-submenu index="5">
									<template slot="title"><img src="../src/assets/智能排班.png">&nbsp;&nbsp;智能排班</template>
									<el-menu-item-group>
										<el-menu-item v-if="Jurisdiction.AttendanceGroup == 'AttendanceGroup'" index="5-1"
											@click="goTo('KqzGl')">考勤组管理</el-menu-item>
										<el-menu-item v-if="Jurisdiction.ProjectManagement == 'ProjectManagement'"
											index="5-2" @click="goTo('QyxmGl')">签约项目管理</el-menu-item>
										<!-- <el-menu-item index="5-3" @click="goTo('YdgzrSd')">月度工作日设定</el-menu-item> -->
										<el-menu-item v-if="Jurisdiction.WorkforceManagement == 'WorkforceManagement'"
											index="5-4" @click="goTo('ZnPb')">排班管理</el-menu-item>
									</el-menu-item-group>
								</el-submenu>

								<el-submenu index="6">
									<template slot="title"><img src="../src/assets/考勤管理.png">&nbsp;&nbsp;考勤管理</template>
									<el-menu-item-group>
										<el-menu-item v-if="Jurisdiction.PunchDetails == 'PunchDetails'" index="6-1"
											@click="goTo('dkmx')">打卡明细查询</el-menu-item>
										<el-menu-item v-if="Jurisdiction.PunchInPhotoQuery == 'PunchInPhotoQuery'"
											index="6-4" @click="goTo('Dkzp')">打卡照片查询</el-menu-item>
										<el-menu-item v-if="Jurisdiction.AttendanceSummary == 'AttendanceSummary'"
											index="6-2" @click="goTo('KqHz')">考勤汇总</el-menu-item>
										<!-- <el-menu-item v-if="Jurisdiction.AttendanceStatistics == 'AttendanceStatistics'"
											index="6-3">出勤率统计</el-menu-item> -->
									</el-menu-item-group>
								</el-submenu>

								<el-submenu index="10">
									<template slot="title"><img src="../src/assets/工资核算管理.png">&nbsp;&nbsp;工资核算管理</template>
									<el-menu-item-group>
										<el-menu-item v-if="Jurisdiction.SalaryDetails == 'SalaryDetails'" index="10-1"
											@click="goTo('GzMx')">工资明细表</el-menu-item>
										<el-menu-item
											v-if="Jurisdiction.SalaryDetailsSupplement == 'SalaryDetailsSupplement'"
											index="10-9" @click="goTo('GzmxBc')">工资明细表-补充</el-menu-item>
										<el-menu-item v-if="Jurisdiction.Proportion_of_Wages == 'Proportion_of_Wages'"
											index="10-8" @click="goTo('GzZb')">工资占比表</el-menu-item>
										<el-menu-item v-if="Jurisdiction.ProportionSummary == 'ProportionSummary'"
											index="10-10" @click="goTo('GzHz')">工资汇总表</el-menu-item>
										<el-menu-item v-if="Jurisdiction.PayrollSummary == 'PayrollSummary'" index="10-2"
											@click="goTo('GzffHz')">工资发放汇总表</el-menu-item>
										<el-menu-item v-if="Jurisdiction.PayrollSplitSummary == 'PayrollSplitSummary'"
											index="10-3" @click="goTo('GzcfHz')">工资拆分汇总表</el-menu-item>
										<el-menu-item
											v-if="Jurisdiction.SalarySplitCashStatement == 'SalarySplitCashStatement'"
											index="10-4" @click="goTo('GzcfMx')">工资拆分明细表</el-menu-item>
										<!-- <el-menu-item v-if="Jurisdiction.PayrollSplitBankCardDetails == 'PayrollSplitBankCardDetails'" index="10-5" @click="goTo('GzcfyhkMx')">工资拆分银行卡明细表</el-menu-item> -->
										<!-- <el-menu-item v-if="Jurisdiction.DetailedStatementSalarySplitAndFiveInsurances == 'DetailedStatementSalarySplitAndFiveInsurances'" index="10-6" @click="goTo('GzcfwxMx')">工资拆分五险明细表</el-menu-item> -->
										<el-menu-item
											v-if="Jurisdiction.DistributionRatioSetting == 'DistributionRatioSetting'"
											index="10-7" @click="goTo('FfblSz')">发放比率设置</el-menu-item>
										<el-menu-item v-if="Jurisdiction.CalculationMethod == 'CalculationMethod'"
											index="10-11" @click="goTo('Jsfs')">计算方式</el-menu-item>
									</el-menu-item-group>
								</el-submenu>

								<el-submenu index="7">
									<template slot="title"><img src="../src/assets/行政管理.png">&nbsp;&nbsp;行政管理</template>
									<el-menu-item-group>
										<el-menu-item
											v-if="Jurisdiction.DormitoryRoomManagement == 'DormitoryRoomManagement'"
											index="7-1" @click="goTo('SsfjGl')">宿舍房间管理</el-menu-item>
										<el-menu-item
											v-if="Jurisdiction.DormitoryOccupancyManagement == 'DormitoryOccupancyManagement'"
											index="7-2" @click="goTo('SsrzGl')">宿舍入住管理</el-menu-item>
										<el-menu-item
											v-if="Jurisdiction.DormitoryCheckManagement == 'DormitoryCheckManagement'"
											index="7-3" @click="goTo('SstzGl')">宿舍退住管理</el-menu-item>
										<el-menu-item v-if="Jurisdiction.LtemManagement == 'LtemManagement'" index="7-4"
											@click="goTo('WpGl')">物品管理</el-menu-item>
										<el-menu-item v-if="Jurisdiction.LtemLendingManagement == 'LtemLendingManagement'"
											index="7-5" @click="goTo('WpjcGl')">物品借出管理</el-menu-item>
										<el-menu-item v-if="Jurisdiction.LtemReturnManagement == 'LtemReturnManagement'"
											index="7-6" @click="goTo('WpghGl')">物品归还管理</el-menu-item>
										<el-menu-item v-if="Jurisdiction.LtemComprehensiveQuery == 'LtemComprehensiveQuery'"
											index="7-7" @click="goTo('WpzhCx')">物品综合查询</el-menu-item>
									</el-menu-item-group>
								</el-submenu>

								<el-submenu index="12">
									<template slot="title"><img
											src="../src/assets/导航-投标管理-绿.png">&nbsp;&nbsp;投标管理</template>
									<el-menu-item-group>
										<el-menu-item v-if="Jurisdiction.BidMargin == 'BidMargin'" index="12-1"
											@click="goTo('Bond')">保证金管理</el-menu-item>
									</el-menu-item-group>
									<el-menu-item-group>
										<el-menu-item v-if="Jurisdiction.BidPerformanceBond == 'BidPerformanceBond'"
											index="12-2" @click="goTo('Performance')">履约金管理</el-menu-item>
									</el-menu-item-group>
									<el-menu-item-group>
										<el-menu-item v-if="Jurisdiction.BidPerformanceAnalysis == 'BidPerformanceAnalysis'"
											index="12-3" @click="goTo('Agreement')">履约分析表</el-menu-item>
									</el-menu-item-group>
									<el-menu-item-group>
										<el-menu-item v-if="Jurisdiction.BidSummary == 'BidSummary'" index="12-4"
											@click="goTo('Gather')">投标汇总表</el-menu-item>
									</el-menu-item-group>
								</el-submenu>

								<el-submenu index="14">
									<template slot="title"><img src="../src/assets/系统管理.png">&nbsp;&nbsp;应收帐款管理</template>
									<el-menu-item-group>
										<el-menu-item
											v-if="Jurisdiction.AccountsReceivableManage == 'AccountsReceivableManage'"
											index="14-1" @click="goTo('Receivable')">应收帐款管理</el-menu-item>
									</el-menu-item-group>
									<el-menu-item-group>
										<el-menu-item v-if="Jurisdiction.AccountsCollectionPlan == 'AccountsCollectionPlan'"
											index="14-2" @click="goTo('Collection')">回款计划管理</el-menu-item>
									</el-menu-item-group>
									<el-menu-item-group>
										<el-menu-item v-if="Jurisdiction.AccountsRegistration == 'AccountsRegistration'"
											index="14-3" @click="goTo('Invoicebill')">发票登记管理</el-menu-item>
									</el-menu-item-group>
									<el-menu-item-group>
										<el-menu-item
											v-if="Jurisdiction.AccountsAccountsReceivableCleaning == 'AccountsAccountsReceivableCleaning'"
											index="14-6" @click="goTo('Cleaning')">保洁应收账款表</el-menu-item>
									</el-menu-item-group>
									<el-menu-item-group>
										<el-menu-item
											v-if="Jurisdiction.AccountsAccountsReceivableSecurity == 'AccountsAccountsReceivableSecurity'"
											index="14-5" @click="goTo('Securitystaff')">保安应收账款表</el-menu-item>
									</el-menu-item-group>
									<el-menu-item-group>
										<el-menu-item v-if="Jurisdiction.AccountsDataAnalysis == 'AccountsDataAnalysis'"
											index="14-8" @click="goTo('Collectiondata')">回款数据分析表</el-menu-item>
									</el-menu-item-group>
									<el-menu-item-group>
										<el-menu-item v-if="Jurisdiction.AccountsDetail == 'AccountsDetail'" index="14-4"
											@click="goTo('DetailspartyA')">甲方欠款系列明细表</el-menu-item>
									</el-menu-item-group>
									<el-menu-item-group>
										<el-menu-item v-if="Jurisdiction.AccountsSummary == 'AccountsSummary'" index="14-7"
											@click="goTo('DetailsparB')">甲方欠款系列汇总表</el-menu-item>
									</el-menu-item-group>
								</el-submenu>

								<el-submenu index="15">
									<template slot="title"><img src="../src/assets/预算管理_未选中.png">&nbsp;&nbsp;预算管理</template>
									<el-menu-item-group>
										<el-menu-item v-if="Jurisdiction.BudgetOrganization == 'BudgetOrganization'"
											index="15-1" @click="goTo('Budgeting')">预算编制</el-menu-item>
									</el-menu-item-group>
									<el-menu-item-group>
										<el-menu-item v-if="Jurisdiction.BudgetSummary == 'BudgetSummary'" index="15-2"
											@click="goTo('Summary')">预算汇总查询表</el-menu-item>
									</el-menu-item-group>
									<el-menu-item-group>
										<el-menu-item v-if="Jurisdiction.BudgetManage == 'BudgetManage'" index="15-3"
											@click="goTo('Budmanagement')">预算管理</el-menu-item>
									</el-menu-item-group>
									<!-- <el-menu-item-group>
										<el-menu-item index="15-4" @click="goTo('Implementation')">预算执行</el-menu-item>
									</el-menu-item-group> -->
									<el-menu-item-group>
										<el-menu-item v-if="Jurisdiction.BudgetSplit == 'BudgetSplit'" index="15-5"
											@click="goTo('Budsplitting')">预算拆分</el-menu-item>
									</el-menu-item-group>
								</el-submenu>

								<el-menu-item
									v-if="Jurisdiction.MobilizationMeasurementMmanage == 'MobilizationMeasurementMmanage'"
									index="16" @click="goTo('Mobilization')">
									<img src="../src/assets/进场测算管理_未选中.png">
									<span slot="title">&nbsp;进场测算管理</span>
								</el-menu-item>

								<el-submenu index="13">
									<template slot="title"><img src="../src/assets/系统管理.png">&nbsp;&nbsp;OA管理</template>
									<el-menu-item-group>
										<el-menu-item v-if="Jurisdiction.OaSetup == 'OaSetup'" index="13-1"
											@click="goTo('approve')">OA审批</el-menu-item>
										<el-menu-item v-if="Jurisdiction.OaExamineApprove == 'OaExamineApprove'"
											index="13-2" @click="goTo('set')">OA设置</el-menu-item>
									</el-menu-item-group>
								</el-submenu>

								<el-submenu index="8">
									<template slot="title"><img src="../src/assets/系统管理.png">&nbsp;&nbsp;系统管理</template>
									<el-menu-item-group>
										<el-menu-item v-if="Jurisdiction.UserManagement == 'UserManagement'" index="8-1"
											@click="goTo('user')">用户管理</el-menu-item>
										<el-menu-item v-if="Jurisdiction.RoleManagement == 'RoleManagement'" index="8-2"
											@click="goTo('role')">角色管理</el-menu-item>
										<el-menu-item v-if="Jurisdiction.PostManagement == 'PostManagement'" index="8-3"
											@click="goTo('post')">岗位管理</el-menu-item>
										<el-menu-item
											v-if="Jurisdiction.ApprovalProcessManagement == 'ApprovalProcessManagement'"
											index="8-4" @click="goTo('flow')">审批流管理</el-menu-item>
										<el-menu-item 
											v-if="Jurisdiction.AdministratorControl == 'AdministratorControl'"
											index="8-5" @click="goTo('setter')">管理员设置</el-menu-item>
									</el-menu-item-group>
								</el-submenu>

								<el-submenu index="9" v-if="Jurisdiction.DataDictionary == 'DataDictionary'">
									<template slot="title"><img src="../src/assets/数据字典.png">&nbsp;&nbsp;数据字典</template>
									<el-menu-item-group>
										<el-menu-item index="9-1" @click="goTo('first_degree')">第一学历</el-menu-item>
										<el-menu-item index="9-2" @click="goTo('second_degree')">最高学历</el-menu-item>
										<el-menu-item index="9-3" @click="goTo('entry_type')">入职类型</el-menu-item>
										<el-menu-item index="9-4" @click="goTo('recruitment_method')">招聘方式
										</el-menu-item>
										<el-menu-item index="9-5" @click="goTo('health')">健康状况</el-menu-item>
										<el-menu-item index="9-6" @click="goTo('household_register')">户籍性质
										</el-menu-item>
										<el-menu-item index="9-7" @click="goTo('staff_type')">员工类别</el-menu-item>
										<el-menu-item index="9-8" @click="goTo('insurance_type')">投保类别</el-menu-item>
										<el-menu-item index="9-9" @click="goTo('underwriting_type')">承保公司</el-menu-item>
										<el-menu-item index="9-10" @click="goTo('room_type')">房间类别</el-menu-item>
										<el-menu-item index="9-11" @click="goTo('article_type')">物品类别</el-menu-item>
										<!-- <el-menu-item index="9-12" @click="goTo('province')">省份</el-menu-item>
								        <el-menu-item index="9-13" @click="goTo('cities')">城市</el-menu-item> -->
										<el-menu-item index="9-14" @click="goTo('bank')">银行</el-menu-item>
										<el-menu-item index="9-15" @click="goTo('resignation_reason')">离职原因
										</el-menu-item>
										<el-menu-item index="9-16" @click="goTo('leave_type')">请假类型</el-menu-item>
										<el-menu-item index="9-17" @click="goTo('errand_type')">出差方式</el-menu-item>
										<el-menu-item index="9-18" @click="goTo('contract_type')">合同类别</el-menu-item>
										<el-menu-item index="9-19" @click="goTo('bonus_penalty')">奖惩类别</el-menu-item>
										<el-menu-item index="9-20" @click="goTo('change_salary')">调薪类型</el-menu-item>
										<el-menu-item index="9-21" @click="goTo('age_group')">年龄段类型</el-menu-item>
										<el-menu-item index="9-22" @click="goTo('traffic_vehicle')">交通工具</el-menu-item>
										<el-menu-item index="9-23" @click="goTo('agency_company')">代发公司</el-menu-item>
										<el-menu-item index="9-24" @click="goTo('split_account')">拆分账户</el-menu-item>
										<el-menu-item index="9-25" @click="goTo('business_sector')">业务板块</el-menu-item>
										<el-menu-item index="9-26" @click="goTo('business_series')">业务系列</el-menu-item>
										<el-menu-item index="9-27" @click="goTo('material')">物料表</el-menu-item>
										<el-menu-item index="9-28" @click="goTo('fixedassets')">固定资产表</el-menu-item>
										<el-menu-item index="9-29" @click="goTo('integration')">集成字段</el-menu-item>
									</el-menu-item-group>
								</el-submenu>

								<el-submenu index="11">
									<template slot="title"><img src="../src/assets/系统管理.png">&nbsp;&nbsp;报表中心</template>
									<el-menu-item-group>
										<el-menu-item index="11-1"
											v-if="Jurisdiction.ReportEntryResignation == 'ReportEntryResignation'"
											@click="goTo('entry_exit')">入离职报表</el-menu-item>
										<el-menu-item index="11-2"
											v-if="Jurisdiction.StaffBasicInformation == 'StaffBasicInformation'"
											@click="goTo('employee_info')">员工基本信息</el-menu-item>
										<el-menu-item index="11-3"
											v-if="Jurisdiction.ReportFiveInsuranceStatistics == 'ReportFiveInsuranceStatistics'"
											@click="goTo('five_insurances_statistical')">五险统计表
										</el-menu-item>
										<el-menu-item index="11-4"
											v-if="Jurisdiction.ReportFiveInsuranceDetail == 'ReportFiveInsuranceDetail'"
											@click="goTo('five_insurances_detailed')">五险明细表
										</el-menu-item>
										<el-menu-item index="11-5"
											v-if="Jurisdiction.ReportInsuranceSettlement == 'ReportInsuranceSettlement'"
											@click="goTo('employer_insurance')">雇主险费用及理赔
										</el-menu-item>
										<el-menu-item index="11-6"
											v-if="Jurisdiction.ReportInsuranceStatistics == 'ReportInsuranceStatistics'"
											@click="goTo('employer_insurance_statistical')">雇主险电动车统计
										</el-menu-item>
										<el-menu-item index="11-7"
											v-if="Jurisdiction.ReportOtherRisks == 'ReportOtherRisks'"
											@click="goTo('electric_vehicle_insurance')">电动车险费用及理赔
										</el-menu-item>
										<el-menu-item index="11-8"
											v-if="Jurisdiction.ProjectAddressBook == 'ProjectAddressBook'"
											@click="goTo('project_address_book')">项目通讯录
										</el-menu-item>
										<el-menu-item index="11-9"
											v-if="Jurisdiction.ReportProjectCondition == 'ReportProjectCondition'"
											@click="goTo('project_natural_conditions')">项目自然情况表
										</el-menu-item>
										<el-menu-item index="11-10"
											v-if="Jurisdiction.ReportProjectAssessment == 'ReportProjectAssessment'"
											@click="goTo('project_assessment')">项目考核表</el-menu-item>
										<el-menu-item index="11-11"
											v-if="Jurisdiction.ReportBigRanking == 'ReportBigRanking'"
											@click="goTo('big_ranking')">大排名</el-menu-item>
										<el-menu-item index="11-12" 
											v-if="Jurisdiction.BudgetComparison == 'BudgetComparison'"
											@click="goTo('budget_comparison_table')">预算对比报表</el-menu-item>
									</el-menu-item-group>
								</el-submenu>
							</el-menu>
						</el-scrollbar>
					</el-col>
				</el-row>
			</div>
		</div>

		<div>
			<el-dialog title="修改密码" :visible.sync="dialogVisible" width="30%" :close-on-click-modal="false" :center="true">

				<el-form :model="from" :rules="rules" ref="from" style="padding: 0 10%;" label-width="100px">
					<el-form-item label="原密码" prop="oldPwd">
						<el-input v-model="from.oldPwd" placeholder="请输入原密码" style="width: 100%;"></el-input>
					</el-form-item>
					<el-form-item label="新密码" prop="newPwd">
						<el-input v-model="from.newPwd" placeholder="请输入新密码" style="width: 100%;"></el-input>
					</el-form-item>
					<el-form-item label="确认密码" prop="newPwdS">
						<el-input v-model="from.newPwdS" placeholder="请再次输入新密码" style="width: 100%;"></el-input>
					</el-form-item>
					<el-form-item style="text-align: center;" label-width="0px">
						<el-button type="primary" @click="Update"
							style="width: 30%; background-color: #006E4B; border: 1px solid #006E4B;">确 定</el-button>
					</el-form-item>
				</el-form>

			</el-dialog>
		</div>
	</div>
</template>

<script>
import axios from "axios";
import Bus from "./js/bus";
export default {
	data() {
		return {
			from: {
				oldPwd: "",
				newPwd: "",
				newPwdS: "",
			},
			dialogVisible: false,
			datalist: [],
			user_name: this.$globals.user.name,
			user_id: this.$globals.user.id,
			Jurisdiction: {
				contract: this.$globals.user.sysJurisdictionList.contract, //合同模板管理
				Examine: this.$globals.user.sysJurisdictionList.Examine, //合同模板审核
				launch: this.$globals.user.sysJurisdictionList.launch, //合同签订发起
				ContractSigning: this.$globals.user.sysJurisdictionList.ContractSigning, //合同签订
				ContractArchiving: this.$globals.user.sysJurisdictionList.ContractArchiving, //合同归档
				profileInformation: this.$globals.user.sysJurisdictionList.profileInformation, //员工档案信息
				titleManagement: this.$globals.user.sysJurisdictionList.titleManagement, //合同名头管理
				FilesProjectContract: this.$globals.user.sysJurisdictionList.FilesProjectContract, //项目合同

				organization: this.$globals.user.sysJurisdictionList.organization, //集团组织架构管理
				EmployeeList: this.$globals.user.sysJurisdictionList.EmployeeList, //员工信息列表
				StaffContract: this.$globals.user.sysJurisdictionList.StaffContract, //员工合同签订
				StaffBecomeFormal: this.$globals.user.sysJurisdictionList.StaffBecomeFormal, //员工转正
				Induction: this.$globals.user.sysJurisdictionList.Induction, //员工入职
				quit: this.$globals.user.sysJurisdictionList.quit, //员工离职
				StaffTransferPost: this.$globals.user.sysJurisdictionList.StaffTransferPost, //员工调岗
				management: this.$globals.user.sysJurisdictionList.management, //黑名单管理
				Insurance_base_management: this.$globals.user.sysJurisdictionList.Insurance_base_management, //保险基数管理
				StaffGoOut: this.$globals.user.sysJurisdictionList.StaffGoOut, //外出申请
				StaffLeave: this.$globals.user.sysJurisdictionList.StaffLeave, //请假申请
				StaffTravel: this.$globals.user.sysJurisdictionList.StaffTravel, //出差申请
				StaffMake: this.$globals.user.sysJurisdictionList.StaffMake, //补卡申请
				StaffOvertime: this.$globals.user.sysJurisdictionList.StaffOvertime, //加班申请
				StaffPostSupport: this.$globals.user.sysJurisdictionList.StaffPostSupport, //岗位支援申请
				StaffSupport: this.$globals.user.sysJurisdictionList.StaffSupport, //岗位支援
				StaffSupportAccept: this.$globals.user.sysJurisdictionList.StaffSupportAccept, //岗位支援接收
				StaffReplacePost: this.$globals.user.sysJurisdictionList.StaffReplacePost, //代岗申请
				StaffWages: this.$globals.user.sysJurisdictionList.StaffWages, //工资申请单
				StaffChangeSalary: this.$globals.user.sysJurisdictionList.StaffChangeSalary, //整体调薪
				StaffExamine: this.$globals.user.sysJurisdictionList.StaffExamine, //OA审批

				UnpaidInsurance: this.$globals.user.sysJurisdictionList.UnpaidInsurance, //未缴纳雇主险
				EmployerInsurance: this.$globals.user.sysJurisdictionList.EmployerInsurance, //雇主险管理
				Insurance_Premium_Management: this.$globals.user.sysJurisdictionList
					.Insurance_Premium_Management, //雇主险保费管理
				EmployerDanger: this.$globals.user.sysJurisdictionList.EmployerDanger, //雇主险出险
				OtherRisks: this.$globals.user.sysJurisdictionList.OtherRisks, //其他险种管理
				OtherDanger: this.$globals.user.sysJurisdictionList.OtherDanger, //其他险种出险

				AttendanceGroup: this.$globals.user.sysJurisdictionList.AttendanceGroup, //考勤组管理
				ProjectManagement: this.$globals.user.sysJurisdictionList.ProjectManagement, //签约项目管理
				WorkforceManagement: this.$globals.user.sysJurisdictionList.WorkforceManagement, //排班管理

				PunchDetails: this.$globals.user.sysJurisdictionList.PunchDetails, //打卡明细查询
				AttendanceSummary: this.$globals.user.sysJurisdictionList.AttendanceSummary, //考勤汇总
				AttendanceStatistics: this.$globals.user.sysJurisdictionList.AttendanceStatistics, //出勤率统计
				PunchInPhotoQuery: this.$globals.user.sysJurisdictionList.PunchInPhotoQuery, //打卡照片查看

				SalaryDetails: this.$globals.user.sysJurisdictionList.SalaryDetails, //工资明细表
				SalaryDetailsSupplement: this.$globals.user.sysJurisdictionList.SalaryDetailsSupplement, //工资明细表-补充
				Proportion_of_Wages: this.$globals.user.sysJurisdictionList.Proportion_of_Wages, //工资占比表
				ProportionSummary: this.$globals.user.sysJurisdictionList.ProportionSummary, //工资汇总表
				PayrollSummary: this.$globals.user.sysJurisdictionList.PayrollSummary, //工资发放汇总表
				PayrollSplitSummary: this.$globals.user.sysJurisdictionList.PayrollSplitSummary, //工资拆分汇总表
				SalarySplitCashStatement: this.$globals.user.sysJurisdictionList.SalarySplitCashStatement, //工资拆分现金明细表
				PayrollSplitBankCardDetails: this.$globals.user.sysJurisdictionList.PayrollSplitBankCardDetails, //工资拆分银行卡明细表
				DetailedStatementSalarySplitAndFiveInsurances: this.$globals.user.sysJurisdictionList.DetailedStatementSalarySplitAndFiveInsurances, //工资拆分五险明细表
				DistributionRatioSetting: this.$globals.user.sysJurisdictionList.DistributionRatioSetting, //发放比率设置
				CalculationMethod: this.$globals.user.sysJurisdictionList.CalculationMethod, //计算方式

				OaSetup: this.$globals.user.sysJurisdictionList.OaSetup, //OaSetup
				OaExamineApprove: this.$globals.user.sysJurisdictionList.OaExamineApprove, //OaExamineApprove

				MobilizationMeasurementMmanage: this.$globals.user.sysJurisdictionList.MobilizationMeasurementMmanage, //进场测算管理

				BudgetSplit: this.$globals.user.sysJurisdictionList.BudgetSplit, //预算拆分
				BudgetManage: this.$globals.user.sysJurisdictionList.BudgetManage, //预算管理
				BudgetSummary: this.$globals.user.sysJurisdictionList.BudgetSummary, //预算汇总查询表
				BudgetOrganization: this.$globals.user.sysJurisdictionList.BudgetOrganization, //预算编制

				AccountsSummary: this.$globals.user.sysJurisdictionList.AccountsSummary, //甲方欠款系列汇总表
				AccountsDetail: this.$globals.user.sysJurisdictionList.AccountsDetail, //甲方欠款系列明细表
				AccountsDataAnalysis: this.$globals.user.sysJurisdictionList.AccountsDataAnalysis, //回款数据分析表
				AccountsAccountsReceivableSecurity: this.$globals.user.sysJurisdictionList.AccountsAccountsReceivableSecurity, //保安应收账款表
				AccountsAccountsReceivableCleaning: this.$globals.user.sysJurisdictionList.AccountsAccountsReceivableCleaning, //保洁应收账款表
				AccountsRegistration: this.$globals.user.sysJurisdictionList.AccountsRegistration, //发票登记管理
				AccountsCollectionPlan: this.$globals.user.sysJurisdictionList.AccountsCollectionPlan, //回款计划管理
				AccountsReceivableManage: this.$globals.user.sysJurisdictionList.AccountsReceivableManage, //应收帐款管理

				BidSummary: this.$globals.user.sysJurisdictionList.BidSummary, //投标汇总表
				BidPerformanceAnalysis: this.$globals.user.sysJurisdictionList.BidPerformanceAnalysis, //履约分析表
				BidPerformanceBond: this.$globals.user.sysJurisdictionList.BidPerformanceBond, //履约金管理
				BidMargin: this.$globals.user.sysJurisdictionList.BidMargin, //保证金管理

				DormitoryRoomManagement: this.$globals.user.sysJurisdictionList.DormitoryRoomManagement, //宿舍房间管理
				DormitoryOccupancyManagement: this.$globals.user.sysJurisdictionList.DormitoryOccupancyManagement, //宿舍入住管理
				DormitoryCheckManagement: this.$globals.user.sysJurisdictionList.DormitoryCheckManagement, //宿舍退住管理
				LtemManagement: this.$globals.user.sysJurisdictionList.LtemManagement, //物品管理
				LtemLendingManagement: this.$globals.user.sysJurisdictionList.LtemLendingManagement, //物品借出管理
				LtemReturnManagement: this.$globals.user.sysJurisdictionList.LtemReturnManagement, //物品归还管理
				LtemComprehensiveQuery: this.$globals.user.sysJurisdictionList.LtemComprehensiveQuery, //物品综合查询

				UserManagement: this.$globals.user.sysJurisdictionList.UserManagement, //用户管理
				RoleManagement: this.$globals.user.sysJurisdictionList.RoleManagement, //角色管理
				PostManagement: this.$globals.user.sysJurisdictionList.PostManagement, //岗位管理
				ApprovalProcessManagement: this.$globals.user.sysJurisdictionList.ApprovalProcessManagement, //审批流管理
				AdministratorControl:this.$globals.user.sysJurisdictionList.AdministratorControl,//管理员设置

				DataDictionary: this.$globals.user.sysJurisdictionList.DataDictionary, //数据字典

				PunchClock: this.$globals.user.sysJurisdictionList.PunchClock, //打卡

				ReportEntryResignation: this.$globals.user.sysJurisdictionList.ReportEntryResignation, //入离职报表
				StaffBasicInformation: this.$globals.user.sysJurisdictionList.StaffBasicInformation, //员工基本信息
				ReportFiveInsuranceStatistics: this.$globals.user.sysJurisdictionList.ReportFiveInsuranceStatistics, //五险统计表
				ReportFiveInsuranceDetail: this.$globals.user.sysJurisdictionList.ReportFiveInsuranceDetail, //五险明细表
				ReportInsuranceSettlement: this.$globals.user.sysJurisdictionList.ReportInsuranceSettlement, //雇主险费用及理赔
				ReportInsuranceStatistics: this.$globals.user.sysJurisdictionList.ReportInsuranceStatistics, //雇主险电动车统计
				ReportOtherRisks: this.$globals.user.sysJurisdictionList.ReportOtherRisks, //电动车险费用及理赔
				ProjectAddressBook: this.$globals.user.sysJurisdictionList.ProjectAddressBook, //项目通讯录
				ReportProjectCondition: this.$globals.user.sysJurisdictionList.ReportProjectCondition, //项目自然情况表
				ReportProjectAssessment: this.$globals.user.sysJurisdictionList.ReportProjectAssessment, //项目考核表
				ReportBigRanking: this.$globals.user.sysJurisdictionList.ReportBigRanking, //大排名
				BudgetComparison: this.$globals.user.sysJurisdictionList.BudgetComparison, //预算对比报表

			},

			//表单验证
			rules: {
				oldPwd: [{
					required: true,
					message: '请输入原密码！',
					trigger: 'blur'
				}],
				newPwd: [{
					required: true,
					message: '请输入新密码！',
					trigger: 'blur'
				}],
				newPwdS: [{
					required: true,
					message: '请输入确认密码！',
					trigger: 'blur'
				}],
			}
		};
	},
	methods: {
		goTo(path) {
			Bus.$emit("fn", path);
			this.$router.replace("/" + path);
		},
		signout() {
			this.$session.set("token", false);
			this.$router.push('/')
			history.pushState(null, null, document.URL);
		},

		Uppwd() {
			this.dialogVisible = true;
			this.from.oldPwd = "";
			this.from.newPwd = "";
			this.from.newPwdS = "";
		},

		Update() {
			this.$refs["from"].validate(async (valid) => {
				if (valid) {
					if (this.from.newPwd != this.from.newPwdS) {
						this.$message.error("新密码不一致,请检查");
						return;
					}
					var url = "user/modifyPwd";
					var record = {
						id: this.user_id,
						newPwd: this.from.newPwd,
						pwd: this.from.oldPwd
					};
					var data = await this.$globals.AxiosPost(url, record);
					if (data === "-2000") {
						this.$message.error("服务器未响应！请稍后重试");
					} else {
						var code = data.code;
						var data = data.data;
						if (code === '200') {
							this.$message.success(data);
							this.dialogVisible = false;
							this.from.oldPwd = "";
							this.from.newPwd = "";
							this.from.newPwdS = "";
						} else {
							this.$message.warning(data);
						}
					}
				}
			});
		}
	},
	async created() {
		//当前登陆人信息
		// if (this.$session.get("user") != undefined) {
		//     var data = JSON.parse(this.$session.get("user"));
		//     this.$globals.user.id = data.id;
		//     this.$globals.user.name = data.name;
		//     this.$globals.user.role_id = data.role_id;
		//     this.$globals.user.staff_id = data.staff_id;
		//     this.$globals.user.phone = data.phone;
		//     this.$globals.user.mailbox = data.mailbox;
		//     this.$globals.user.sysJurisdictionList = data.sysJurisdictionList;
		// }




		//获取集团名称
		var group = await this.$globals.AxiosPost("dictionaries/groupFind", {});
		this.$globals.group_name = group.data.group_company;
	}
}
</script>



<style scoped>
>>>.el-menu-item.is-active {
	background-color: #EBF4F1 !important;
	border-left: 3px solid #00704C;
}

>>>.el-submenu :hover {
	background-color: white;
}

>>>.el-menu-item:hover {
	color: #00704C !important;
	background-color: #eaf7ff;
}

>>>.el-menu-item-group__title {
	padding: 0;
}

.page-scroll {

	height: 100%;

}

/deep/.el-scrollbar__wrap {
	overflow-x: hidden;
}
</style>



// WEBPACK FOOTER //
// Main.vue?660fd750